import React, { useEffect, useMemo, useState } from 'react';
import { fetchCommandsExecuted, fetchCommandsPending } from '../utils/api';


const formatDateTime = (value) => {
  if (!value) return 'N/A';
  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) return String(value);
  return parsedDate.toLocaleString();
};

function CommandsExecuted() {
  const [filter, setFilter] = useState('executed');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const title = useMemo(() => {
    if (filter === 'pending') return 'Commands Pending';
    return 'Commands Executed';
  }, [filter]);



  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError('');

      try {
        const data = filter === 'pending' ? await fetchCommandsPending() : await fetchCommandsExecuted();
        setItems(Array.isArray(data) ? data : []);
      } catch (err) {
        setError(err?.message || (filter === 'pending' ? 'Failed to fetch commands pending' : 'Failed to fetch commands executed'));
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [filter]);

  if (loading) {

    return (
      <div className="card home-card h-100">
        <div className="card-body p-3 d-flex align-items-center justify-content-center">
          <div className="spinner-border text-primary" role="status" />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="card home-card h-100">
        <div className="card-body p-3">
          <h6 className="card-title text-center mb-2">Commands Executed</h6>
          <div className="alert alert-danger mb-0">{error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="card home-card h-100">
      <div className="card-body p-3 d-flex flex-column">
        <div className="d-flex align-items-center justify-content-between gap-2 mb-3">
          <h6 className="card-title text-center m-0">{title}</h6>
          <div className="btn-group btn-group-sm" role="group" aria-label="Commands filter">
            <button
              type="button"
              className={`btn ${filter === 'executed' ? 'btn-light' : 'btn-outline-light'}`}
              onClick={() => setFilter('executed')}
            >
              Executed
            </button>
            <button
              type="button"
              className={`btn ${filter === 'pending' ? 'btn-light' : 'btn-outline-light'}`}
              onClick={() => setFilter('pending')}
            >
              Pending
            </button>
          </div>
        </div>


        {items.length === 0 ? (
          <div className="text-muted small">No command executions found.</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-sm table-dark align-middle mb-0">
              <thead>
                <tr>
                  <th>Command</th>
                  <th>Entry</th>
                  <th>Completed</th>
                  <th>Box</th>
                </tr>
              </thead>
              <tbody>
                {items
                  .filter((it) => {
                    const boxId = String(it?.DHTHTBX_id ?? '').trim();
                    return boxId !== '' && boxId !== 'null' && boxId !== 'undefined';
                  })
                  .map((it, idx) => (
                    <tr key={`${it.DHTHBC_entry_Id ?? 'na'}-${it.DHTCMD_id ?? 'na'}-${idx}`}>
                      <td className="text-nowrap">{it.DHTCMD_command || 'N/A'}</td>
                      <td className="text-nowrap">{formatDateTime(it.DHTHBC_entry_Date || it.DHTHBC_entry_Id)}</td>
                      <td className="text-nowrap">{formatDateTime(it.DHTHBC_completed_DateTime || it.DHTHBC_command_DateTime)}</td>
                      <td className="small text-white-50">
                        {`Box: ${it.DHTHTBX_id ?? 'N/A'} | HB: ${it.DHTHBC_entry_Id ?? 'N/A'} | CMD: ${it.DHTCMD_id ?? 'N/A'}`}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default CommandsExecuted;

